import { useContext } from 'react';
import { InformationPopoverContentUI } from './InformationPopoverContentUI';
import SegmentationFiltersSharedContext from '../../state/SegmentationFiltersSharedContext';
import { useAwaitedState } from '../../hooks/useAwaitedState';
import { jsx as _jsx } from "react/jsx-runtime";
export const InformationPopoverContent = ({
  filterFamily,
  name
}) => {
  const {
    getEventDescriptionCached
  } = useContext(SegmentationFiltersSharedContext);
  const descriptionResult = useAwaitedState(getEventDescriptionCached(filterFamily));
  const description = descriptionResult.state === 'fulfilled' ? descriptionResult.value : undefined;
  return /*#__PURE__*/_jsx(InformationPopoverContentUI, {
    label: name,
    loading: descriptionResult.state === 'pending',
    description: description
  });
};